import { Box } from "../../../imports/muiImport";

function MobileProductDetailImage({ image }) {
    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                py: 2,
            }}
        >
            <Box
                sx={{
                    position: 'relative',
                    width: '90%',
                    maxWidth: '90%',
                    paddingTop: '56.25%',
                    borderRadius: 4,
                    boxShadow: 5,
                    overflow: 'hidden',
                    backgroundColor: 'white.main',
                }}
            >
                <Box
                    component="img"
                    src={image}
                    alt="Product Preview"
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                    }}
                />
            </Box>
        </Box>
    );
}

export default MobileProductDetailImage;
